<template>
  <v-snackbar bottom location="right" v-model="snackbar.status" :color="snackbar.color" :timeout="snackbar.timeout">
    <v-row no-gutters align="center">
      <v-progress-circular v-if="snackbar.loading" size="24" indeterminate color="grey lighten-2" class="mr-1"></v-progress-circular>
      <v-icon v-else color="white" class="mr-2">mdi-{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <v-spacer></v-spacer>
      <v-btn v-if="snackbar.closable" variant="text" density="compact" :color="snackbar.close_button_color" @click="setSnackbar({ status: false, text: null })"> {{ t('$vuetify.close') }} </v-btn>
    </v-row>
  </v-snackbar>
</template>

<script setup>
import { computed } from 'vue'

import { useLocale } from 'vuetify'
const { t } = useLocale()

import { useStore } from 'vuex'
const store = useStore()

const snackbar = computed(() => store.state.snackbar)
</script>
